import { z } from 'zod'
import assert from 'assert'

import { EncryptedWallet } from '@/business-logic/wallet/domain/keyring/EncryptedWallet'

const EncryptedWalletDTOSchema = z.object({
  data: z.string(),
  iv: z.string(),
  salt: z.string(),
})

export type EncryptedWalletDTO = z.infer<typeof EncryptedWalletDTOSchema>

export function mapDTOToDomain(dto: unknown): EncryptedWallet {
  assert(
    typeof dto === 'string',
    'Expected dto to be a string while mapping EncryptedWallet'
  )
  const parsedDTO = JSON.parse(dto)
  const { data, iv, salt } = EncryptedWalletDTOSchema.parse(parsedDTO)

  return EncryptedWallet.create({
    data,
    iv,
    salt,
  })
}

export function mapDomainToDTO(
  encryptedWallet: EncryptedWallet
): EncryptedWalletDTO {
  const { data, iv, salt } = encryptedWallet
  return { data, iv, salt }
}
